import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { device } from "../device";
import { FullWidthImage } from "./";

function RuleImage(props) {
    const rule = props.rule;
    const caption = props.caption;
    const last = props.last;
    const ImageContainer = styled.div`
        margin-bottom: ${
            last === 'xs' ? '0' : '32px'
        };
        @media ${device.sm} {
            margin-bottom: ${
                last === 'xs' ? '0' :
                last === 'sm' ? '0' :  
                '48px'
            };
        }
    `;
    const Icon = styled.div`
        font-size: 0;
        margin-bottom: 16px;
    `;

    const Figcaption = styled.div`
        margin-top: 16px;
    `;

    if (rule === 'do') {
        return (
            <ImageContainer>
                <Icon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 22">
                        <path fill="#1DCF88" fillRule="evenodd" d="M8.401 15.772L20.694.102 24 2.635 8.715 21.898 0 13.352l2.967-2.909z"/>
                    </svg>
                </Icon>
                <FullWidthImage src={props.src} alt="" />
                {caption && <Figcaption>{caption}</Figcaption>}
            </ImageContainer>
        )
    }
    return (
        <ImageContainer>
            <Icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="#EA5949" fillRule="evenodd" d="M12 9.09L21.09 0 24 2.91 14.91 12 24 21.09 21.09 24 12 14.91 2.91 24 0 21.09 9.09 12 0 2.91 2.91 0 12 9.09z"/>
                </svg>
            </Icon>
            <FullWidthImage src={props.src} alt="" />
            {caption && <Figcaption>{caption}</Figcaption>}
        </ImageContainer>
    )
}

RuleImage.propTypes = {
    src: PropTypes.string,
    rule: PropTypes.string,
    margin: PropTypes.string
};

export default RuleImage